
export enum IDeviationPriority {
    Normal,
    Critical
}
